export const UNDEFINED = '*'

export const INDEX = '/'

export const PROFILE = '/profile'

export const UNKNOWN = 'unknown'

export const APP_CENTER = '/app-center'

export const CATEGORY = '/explore/category'

export const GAME = '/game'

export const HOME_VIDEO = '/explore'
// 以下路由不會檢查是否使用瀏覽器開啟
export const ROUTE_WHITE_LIST = ['/part-video', '/part-short']
